
import React, { useState, useEffect } from "react";
import { apiFetch } from "../api";

export default function NewSemesterImport({ semesters, onDone }) {
  /* ----------- State ----------- */
  const [name,   setName]   = useState("");
  const [shortS, setShortS] = useState("");
  const [fromId, setFromId] = useState("");     // id des gewählten Alts.
  const [stage,  setStage]  = useState(1);      // 1 = Neues Sem. anlegen
  const [newSem, setNewSem] = useState(null);   // {id, name, short}
  const [courses,setCourses]= useState([]);     // Kurse aus Alts.
  const [sel, setSel]       = useState({});     // Checkbox‑Auswahl

  /* ----- A: neues Semester anlegen ----- */
  const handleCreate = async () => {
    if (!name || !shortS) { alert("Name + Kurzform eingeben"); return; }

    const res = await apiFetch("create_new_semester.php", {
      method: "POST",
      body: JSON.stringify({ name, short: shortS })
    });
    const js = await res.json().catch(() => ({}));


    if (!res.ok || !js.id) { alert(js.error||"Fehler"); return; }

    setNewSem(js);     // {id,name,short}
    setStage(2);       // weiter zu Kurs‑Auswahl
  };

  /* ----- B: Kurse des Quellsemesters laden ----- */
useEffect(() => {
  if (stage !== 2 || !fromId) return;

  const short =
    semesters.find(s => +s.id === +fromId)?.short ?? '';

  console.log('Lade Kurse für', short);

  if (!short) { setCourses([]); return; }

  apiFetch(`list_courses_by_semester.php?season=${encodeURIComponent(short)}`)
      .then(r => r.json())
      .then(arr => setCourses(arr))
      .catch(console.error);
  }, [stage, fromId]);



  /* ----- C: Selektion kopieren ----- */
  const handleImport = async () => {
    const ids = Object.keys(sel).filter(k => sel[k]);
    if (!ids.length) { alert("Bitte mindestens einen Kurs anhaken"); return; }

    const res = await apiFetch("copy_courses.php", {
      method: "POST",
      body: JSON.stringify({
        targetSemesterId: newSem.id,
        courseIds: ids
      })
    });
    const js = await res.json().catch(() => ({}));

    if (!res.ok) { alert(js.error || "Fehler beim Kopieren"); return; }

    alert(`${js.count} Kurs(e) importiert`);
    onDone?.();
  };

  /* ----- Render ----- */
  return (
    <div className="card">
      {stage === 1 && (
        <>
          <h2>Neues Semester anlegen</h2>

          <label>Name:</label>
          <input value={name} onChange={e=>setName(e.target.value)} />

          <label>Kurzform:</label>
          <input value={shortS} onChange={e=>setShortS(e.target.value)} />

          <label>Kurse übernehmen aus:</label>
          <select value={fromId} onChange={e=>setFromId(e.target.value)}>
            <option value="">– bitte wählen –</option>
            {semesters.map(s => (
              <option key={s.id} value={s.id}>{s.name} ({s.short})</option>
            ))}
          </select>

          <div className="modal-actions">
            <button onClick={handleCreate} disabled={!fromId}>Weiter</button>
          </div>
        </>
      )}

      {stage === 2 && (
        <>
          <h2>Kurse aus {semesters.find(s => s.id === +fromId)?.name}</h2>
          <p>Kurse markieren, die nach <b>{newSem.short}</b> kopiert werden sollen.</p>

          <table className="import-table">
            <thead>
              <tr><th></th><th>Titel</th><th>Studiengang</th><th>Anwendung</th></tr>
            </thead>
            <tbody>
            {courses
                .sort((a,b)=>a.course_title.localeCompare(b.course_title,'de'))
                .map(c => (
                <tr key={c.id}>                 
                    <td>
                    <input
                        type="checkbox"
                        checked={!!sel[c.id]}     
                        onChange={e =>
                        setSel(prev => ({ ...prev, [c.id]: e.target.checked }))
                        }
                    />
                    </td>
                    <td>{c.course_title}</td>
                    <td>{c.course_degree}</td>
                    <td>{c.course_application}</td>
                </tr>
            ))}
            </tbody>
          </table>

          <div className="modal-actions">
            <button className="primary" onClick={handleImport}>Import starten</button>
          </div>
        </>
      )}
    </div>
  );
}
